export default __webpack_public_path__ + "static/media/ngocmon.4a208e2f.png";